export const onlineCarrierStatus = {
  connected: "connected",
  notConnected: "notConnected",
  connectionIssue: "connectionIssue",
  // The token is dead, but the backend renews it from the stored account on a click.
  renewable: "renewable",
} as const;

export type OnlineCarrierStatus =
  (typeof onlineCarrierStatus)[keyof typeof onlineCarrierStatus];
